import api from "../../axiosConfig";


export const addFee = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/fee/add-fee', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getFees = async (searchKeyword,doctor_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/fee/all-fee', {
      params: {
        doctor_id:doctor_id,
        search_keyword: searchKeyword,
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

export const updateFee = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    _method: 'put', 
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/fee/update-fee/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};
// export const deletesymptom = async (id) => {
//   try {
//     const response = await api.delete(`symptom/delete/${id}`);

//     const resData = response?.data;
//     console.log('Delete symptom response:', resData);

//     if (resData?.message_type === 'success') {
//       return { success: true, data: resData.message };
//     } else {
//       return { success: false, error: resData.message };
//     }
//   } catch (err) {
//     throw new Error(err.response?.data?.message || 'Error deleting medicine');
//   }
// };